module.exports = __webpack_public_path__ + "img/user.213b340b.svg";